import React from 'react';
import { BaseInputProps, NumberInput } from 'ui-builder';

export interface TeamAutocompleteInputProps extends BaseInputProps<number> {

}

export function TeamIdInput(
  props: TeamAutocompleteInputProps,
) {
  return (
    <NumberInput
      source={props.source}
    />
  );
}
